<div class="rti-modal-dialog overlay" (click)="OnCancel($event)">
  <div class="rti-modal-dialog-container">
    <div class="rti-model-header-container">
      <div>
          <ng-content select="[header-text]"></ng-content>
      </div>
      <div class="rti-modal-dialog-icon" (click)="Close()">
          <mat-icon class="material-icons cancel" aria-label="close" (onClick)="Close()">cancel</mat-icon>
        </div>
    </div>
    <ng-container *ngIf="body else template">
      <ng-container *ngTemplateOutlet="body"></ng-container>
    </ng-container>
    <ng-template #template>
      <ng-content></ng-content>
    </ng-template>
    <div class="rti-modal-dialog-body-action-container" *ngIf="actions?.length > 0">
      <ul class="rti-modal-dialog-body-action-container-action-items">
        <li class="rti-modal-dialog-body-action-container-action-item"
            *ngFor="let action of actions">
          <button mat-button [hidden]="action.disabled"
                  (click)="OnAction(action)">
            {{action.name}}
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
